module.exports = __webpack_public_path__ + "3082938a2c8788bf278f3ac5fa0ddf6b.svg";